<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Klienci</span>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja klienta</template>
          <template v-else>Dodawanie klienta</template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/klienci')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          theme="success"
          @click.prevent="validateForm">
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab title="Dane ogólne" active>
            <h4 class="mb-3 pb-3 border-bottom">
              Dane ogólne
            </h4>

            <validation-observer
              ref="customer-form"
              tag="form">
              <div class="form-group">
                <label for="name">
                  Nazwa klienta:
                </label>

                <validation-provider
                  rules="required"
                  name="name"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="data.name" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </validation-observer>

            <div
              v-if="!allDataLoaded"
              class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>

            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'customer-form',
  computed: {
    allDataLoaded () {
      return this.loaded;
    },
    isEdit () {
      return !!this.$route.params.id;
    }
  },
  data() {
    return {
      data: {
        id: 0,
        name: ''
      },
      loaded: false,
      loadError: false
    };
  },
  mounted () {
    if (this.isEdit) {
      this.loadItemData();
    } else {
      this.loaded = true;
    }
  },
  methods: {
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/customers/item/',
        instanceFields: ['id', 'name'],
        loadedKey: 'loaded'
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['customer-form'], this.submitForm);
    },
    submitForm () {
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = this.isEdit ? '/customers/update/' + this.id : '/customers/store';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano klienta',
        successText: 'Wybrany klient został zapisany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja klienta nie powiodła się. Spróbuj ponownie.',
        successAction: (response) => {
          if (!this.isEdit && response.item && response.item.id) {
            this.$router.push('/klienci/edycja/' + parseInt(response.item.id, 10));
          } else if (this.isEdit) {
            this.loaded = false;
            this.loadItemData();
          } else {
            this.$router.push('/klienci')
          }
        }
      });
    },
    prepareFormDataToSend () {
      let formDataToSend = {
        name: this.data.name
      };

      return formDataToSend;
    }
  }
};
</script>
